import { ExitConfirmBody } from '@repo/ui/overlay';

import { closeAllModals, closeModal, openModal } from 'store/modalStackStore';

// 글 작성 도중 나가게 될 경우, 모달을 열어 정말 나갈 것인지 확인해주는 함수
export const handleOpenExitConfirmationModal = () => {
  openModal(
    <ExitConfirmBody
      title="저장하지 않은 내용이 있어요"
      contents={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <span>작성된 정보가 모두 사라져요</span>
          <span>그래도 나가시겠어요?</span>
          {/* 작성된 정보가 모두 사라져요. <br /> 그래도 나가시겠어요? */}
        </div>
      }
      confirmExit={closeAllModals}
      cancelExit={closeModal}
    />,
    {
      modalWrapperStyle: { maxWidth: 400 },
      closeOnBackdropClick: false,
    }
  );
};
